<!-- src/components/ezer/EzerUserBubble.vue -->
<template>
  <div class="ezer-bubble ezer-bubble--user">
    <div class="ezer-bubble__content">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'EzerUserBubble',
  props: { text: String },
}
</script>
